export default "__VITE_ASSET__DzyclQWS__"